import styled from "styled-components";

const CardContainer = styled.div`
  background-color: white;
`;


const CardHeader = styled.div`
    padding:10px 24px;
    display: flex;
    justify-content:space-between;
//box-shadow: 0px 8px 24px rgba(151, 195, 255, 0.08);

`
const CardTitle = styled.div`
    font-size: 18px;
    font-weight: 400;
`

const CardBody = styled.div`
padding:10px 24px;
background-color: white;
box-shadow: inset 0px 7px 8px rgb(209 209 209 / 16%) !important;
`


type CardProps = {
    title?: string,
    children: any,
    HeaderButton?: React.ReactNode,
    style?: any
}

const Card = ({ title, children, HeaderButton}: CardProps) => {


    return (
        <CardContainer>
            {title && (
                <CardHeader>
                    <CardTitle>{title}</CardTitle>
                    {HeaderButton && <>{HeaderButton} </>}
                </CardHeader>
            )}
            <CardBody>
                {children}
            </CardBody>

        </CardContainer>


    )
}

export default Card;